const OWN_BATCH_SUFFIX = ' - (batch)'

export const ownBatchForItem = (item, { subrecipesByInventoryItemId, subrecipesById } = {}) => {
  if (!item) {
    return null
  }
  const active = subrecipe => (subrecipe && !subrecipe.archived ? subrecipe : null)
  return (item.linked_subrecipe_id && active(subrecipesById?.[item.linked_subrecipe_id])) || active(subrecipesByInventoryItemId?.[item.item_id]) || null
}

export const isOwnBatchItem = (item, state) => !!ownBatchForItem(item, state)

export const ownBatchWithoutRealTimeStock = (item, state) => (state.venue?.use_batch_first_stock ? null : ownBatchForItem(item, state))

export const withOwnBatchSuffix = (titleSuffix = '', isOwnBatch) => titleSuffix.replace(OWN_BATCH_SUFFIX, '') + (isOwnBatch ? OWN_BATCH_SUFFIX : '')

export const isBatchMadeElsewhere = (item, state) => !!item?.linked_subrecipe_id && !ownBatchForItem(item, state)
